import Cookies from "universal-cookie";
import {
  fetchProfileForGroupSwitch,
  fetchProfileForSeekerAwardsTwo,
  userLogin,
  userLogout,
} from "./API/api";
import { BASE_URL, CURRENT_ROLE, currentGroup, UI_BASE_URL } from "./API/url";
import { toast } from "react-toastify";
import moment from "moment";

const cookies = new Cookies();



export const setCookiesAfterLogin = (key, val) => {
  for (let i = 0; i < key.length; ++i) {
    // cookies.set(key[i], val[i]);
    // if(key[i]==='groups'){
    localStorage.setItem(key[i], val[i]);
    // }
  }
  let token = localStorage.getItem("authToken");
  localStorage.setItem("token", token);
  localStorage.setItem("JSESSIONID", token);
};

export const isCookieExist = (key) => {
  let isExist = cookies.get(key) === undefined ? false : true;
  return isExist;
};

export const clearAllCookies = () => {
  let allCookies = cookies.getAll();
  let cookieObjKeys = Object.keys(allCookies);
  for (let i = 0; i < cookieObjKeys.length; ++i) {
    cookies.remove(cookieObjKeys[i]);
  }
};

export const setDataInLS = (key, value) => {
  localStorage.setItem(key, value);
};

export const setCurrentGroupInLSWhileLogin = (data) => {
  let defaultCurrentData = data[0].id;
  setDataInLS("ngStorage-currentGroup", defaultCurrentData);
};

export const removeAllLS = () => {
  localStorage.clear();
};

export const getDataFROMLS = (key) => {
  console.log(localStorage.getItem(key));
  return localStorage.getItem(key);
};

export const getDataFromCookies = (key) => {
  let data = cookies.get(key);
  return localStorage.getItem(key);
};

export const filterDomainsForComponent2 = (obj) => {
  let keys = Object.keys(obj);
  let vals = Object.values(obj);
  let arr = [];
  for (let i = 0; i < keys.length; ++i) {
    arr.push({
      indexId: keys[i],
      name: vals[i],
      label: vals[i],
      value: vals[i],
    });
  }
  return arr;
};
export const filterDomainsForComponent = (arr) => {
  if (arr === undefined) {
    return;
  }
  let filteredDomain = arr.filter((obj) => {
    obj.value = obj.name;
    obj.label = obj.name;
    obj.description = "domain";
    return obj;
  });
  return filteredDomain;
};
export const filterExpertAnsweredFilterData = (data, key) => {
  let newArr = data.filter((obj) => {
    if (obj.description === key) {
      return obj;
    }
  });
  return newArr;
};
export const environmentBasedAuthentication = (dispatchFunc) => {
    // fetchProfileForSeekerAwardsTwo(dispatchFunc);
  //   }
  // if (process.env.REACT_APP_MY_ENVIRONMENT == "production") {
  //   let CurrentRole = JSON.parse(getDataFROMLS("ngStorage-currentRole"));
  //   if (!isCookieExist("userUuid")) {
  //     clearAllCookies();
  //     removeAllLS();
  //     window.location.href = BASE_URL;
  //   } else {
  //     if (
  //       CurrentRole === "Seeker" ||
  //       CurrentRole === "Expert" ||
  //       CurrentRole === "CM" ||
  //       CurrentRole === "Admin" ||
  //       CurrentRole === "Emails"
  //     ) {
  //       fetchProfileForSeekerAwardsTwo(dispatchFunc);
  //     } else {
  //       window.location.href = BASE_URL;
  //     }
  //   }
  // }
  // if(CurrentRole === 'Seeker'){
  if (process.env.REACT_APP_MY_ENVIRONMENT == "development") {
    // userLogin();
    if (!isCookieExist("userUuid")) return;
    fetchProfileForSeekerAwardsTwo(dispatchFunc);
  }
  if (process.env.REACT_APP_MY_ENVIRONMENT == "production") {
    let CurrentRole = JSON.parse(getDataFROMLS("ngStorage-currentRole"));
    if (!isCookieExist("userUuid")) {
      clearAllCookies();
      removeAllLS();
      window.location.href = UI_BASE_URL;
    } else {
      if (
        CurrentRole === "Seeker" ||
        CurrentRole === "Expert" ||
        CurrentRole === "CM" ||
        CurrentRole === "Admin"
      ) {
        fetchProfileForSeekerAwardsTwo(dispatchFunc);
      } else {
        window.location.href = UI_BASE_URL;
      }
    }
  }
};

export const convertEpochToTimestamp = (epoch) => {
  if (epoch !== undefined) {
    let timestamp = new Date(JSON?.parse(epoch));
    return timestamp;
  }
};

export const getcurrentRoleValue = (roles) => {
  if (process.env.REACT_APP_MY_ENVIRONMENT === "production") {
    let getValObj = roles.find((obj) => obj.roleName === CURRENT_ROLE);
    return getValObj.roleId;
  } else {
    let getValObj = roles.find((obj) => obj.roleName === CURRENT_ROLE);
    return getValObj.roleId;
  }
};

export const updateGroups = (groupId) => {
  console.log("groupId", groupId);
  localStorage.setItem("ngStorage-currentGroup", groupId);
  let basicUrl = UI_BASE_URL;
  fetchProfileForGroupSwitch(groupId)
    .then((res) => {
      if (res === undefined) return;
      localStorage.setItem(
        "ngStorage-roles",
        JSON.stringify(res.data.data.roles.map((role) => role.roleName))
      );
      if (res.data.data.roles.find((role) => role.roleName == CURRENT_ROLE)) {
        if (CURRENT_ROLE == "CM") {
          localStorage.setItem("ngStorage-currentRole", JSON.stringify("CM"));
          window.location.href = basicUrl + "/cmHome/";
        } else if (CURRENT_ROLE == "Admin") {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Admin")
          );
          window.location.href = `${basicUrl}/adminhome/`;
        } else if (CURRENT_ROLE == "Expert") {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Expert")
          );
          window.location.href = basicUrl + "/expertHome/open";
        } else if (CURRENT_ROLE == "Seeker") {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Seeker")
          );
          window.location.href = basicUrl + "/seekerHome/";
        }else if (CURRENT_ROLE == "Emails") {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Emails")
          );
          window.location.href = basicUrl + "/emailHome/";
        }
      } else {
        if (res.data.data.roles.find((role) => role.roleName == "CM")) {
          localStorage.setItem("ngStorage-currentRole", JSON.stringify("CM"));
          window.location.href = basicUrl + "/cmHome/";
        } else if (
          res.data.data.roles.find((role) => role.roleName == "Admin")
        ) {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Admin")
          );
          window.location.href = `${basicUrl}/adminhome/`;
        } else if (
          res.data.data.roles.find((role) => role.roleName == "Expert")
        ) {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Expert")
          );
          window.location.href = basicUrl + "/expertHome/open";
        } else if (
          res.data.data.roles.find((role) => role.roleName == "Seeker")
        ) {
          localStorage.setItem(
            "ngStorage-currentRole",
            JSON.stringify("Seeker")
          );
          window.location.href = basicUrl + "/seekerHome/";
        }
      }
    })
    .catch((err) => {
      handleError(err);
    });
};

export const updateRoles = (id, roles) => {
  let getValObj = roles.find((obj) => obj.roleId === parseInt(id));
  let URL = UI_BASE_URL;
  // if (process.env.REACT_APP_MY_ENVIRONMENT === "production") {
  localStorage.setItem(
    "ngStorage-currentRole",
    JSON.stringify(getValObj.roleName)
  );
  if (getValObj.roleName === "Expert") {
    window.location.href = `${URL}/expertHome/open`;
  } else if (getValObj.roleName === "Seeker") {
    window.location.href = `${URL}/seekerHome/`;
  } else if (getValObj.roleName === "CM") {
    window.location.href = `${URL}/cmHome/`;
  } else if (getValObj.roleName === "Emails") {
    window.location.href = `${URL}/emailHome/`;
  } else if (getValObj.roleName === "Admin") {
    window.location.href = `${URL}/adminhome/`;
  } else {
    if (process.env.REACT_APP_MY_ENVIRONMENT === "development") {
      return;
    }
    window.location.href = URL;
  }
  // }
};

export const getQuestionAndAnswerInText = (data) => {
  let question = data.question + "\n\n";
  let answers = "";
  data.answers.filter((elm, index) => {
    answers = answers + `answer${index + 1}: ` + elm.answerText + "\n\n";
  });
  return question + answers;
};

export const NewgetQuestionAndAnswerInText = (data) => {
  let question = data.questionText + "\n\n";
  let answers = "";
  data.answersList.filter((elm, index) => {
    answers = answers + `answer${index + 1}: ` + elm.answerCopy + "\n\n";
  });
  return question + answers;
};

export const createLink = function (data) {
  var uuid = data.questionUuid;
  if (data.origQuestionUuid) {
    uuid = data.origQuestionUuid;
  }
  let link =
    BASE_URL+`${CURRENT_ROLE==='Seeker' ? '/seekerHome/shared/' : '/expertHome/shared/'}${uuid}`;
  return link;
};

export const getTimeForGreeting = () => {
  var today = new Date();
  var curHr = today.getHours();
  if (curHr < 12) {
    return "Good Morning";
  } else if (curHr < 18) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
};

export const handleError = (error) => {
  const errorToast = (message) => {
    return (
      <>
        <p style={{ fontSize: "14px", fontWeight: "bold" }}>Error!</p>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const warningToast = (message) => {
    return (
      <>
        <p style={{ fontSize: "14px", fontWeight: "bold" }}>Warning!</p>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  if (window.navigator.onLine) {
    if (error !== undefined) {
      if (error.response !== undefined) {
        if (error.response.data === undefined) {
          toast.error(errorToast("Not Found!"), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          if (
            error.response.data.status == 401 ||
            error.response.data.status == -1 ||
            typeof error.response.data == "string"
          ) {
            userLogout();
          } else if (error.response.data.status == 403) {
            toast.warning(warningToast(error.response.data.message), {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error(errorToast(error.response.data.message), {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      }
    }
  }
};

export const highlightImpPara = (para, start, end, summarised) => {
  if (start === undefined) {
    return para;
  } else if (summarised === undefined) {
    return para;
  } else {
    if (summarised.includes("VIZSEP")) {
      let newSummarised = summarised.split("VIZSEP");
      for (let i = 0; i < newSummarised.length; ++i) {
        let toReplaced =
          "<span style='font-weight:500'>" + newSummarised[i] + "</span>";
        let fromReplaced = newSummarised[i];
        para = para.replace(fromReplaced, toReplaced);
      }
      return para;
    } else {
      let toReplaced =
        "<span style='font-weight:500'>" + summarised + "</span>";
      let fromReplaced = summarised;
      para = para.replace(fromReplaced, toReplaced);
      return para;
    }
  }
};

export const addTimeSpanToVideoUrl = (link, start, end) => {
  let url = `${link}#t=${start},${end}`;
  return url;
};

export const secondToHour = (second) => {
  let newStamp = moment
    .utc(1000 * second)
    .format(
      second > 3600 ? "H[h] mm[m] ss[s]" : second > 60 ? "mm[m] ss[s]" : "ss[s]"
    );
  // var date = new Date(null);
  // date.setSeconds(second);
  // var result = date.toISOString().substr(11, 8);
  return newStamp;
};

export const replaceContentEditableText = (str) => {
  var validHTMLTagsTextArea =
    /<(h1|h2|h3|h4|h5|h6|\/h1|\/h2|\/h3|\/h4|\/h5|\/h6)[^>]{0,}>/gim;
  let newStr = str.replaceAll(`contenteditable="false"`, "");
  newStr = newStr.replaceAll(validHTMLTagsTextArea, "<p>");
  newStr = newStr.replaceAll("font-size", "");
  newStr = newStr.replaceAll("position:", "");
  newStr = newStr.replaceAll("transform:", "");
  newStr = newStr.replaceAll("<img ", "<img style='max-width:50%'");
  newStr = newStr.replace(
    /(<img\s*[^>]*)(>)/gi,
    "$1 onclick=\"window.open(this.src, '_blank')\"$2"
  );
  return newStr;
};

export const redirectionURL = (point) => {
  switch (point) {
    case "trending":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=trending`;
    case "keyTerm":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=keyTerm`;
    case "open":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=open`;
    case "answered":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=answered`;
    case "history":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=history`;
    case "awards":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=awards`;
    case "home":
      return `${BASE_URL}/seekerHome/`;
    case "favourite":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=favourite`;
    case "profile":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=profile`;
    case "logout":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=logout`;
    case "sharewithme":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=sharewithme`;
    case "sharebyme":
      return `${BASE_URL}/#/seekerHome?group=${currentGroup}&tab=sharebyme`;
    default:
      return `${BASE_URL}/#/seekerHome`;
  }
};

export const removeVIZAPFromText = (str) => {
  let newStr = str.replaceAll("VIZSEP ", "<br/>");
  return newStr;
};

export const handlePlayPause = (id) => {
  let videoElem = document.querySelectorAll("video");
  for (let i = 0; i < videoElem.length; ++i) {
    if (videoElem[i].id !== id) {
      document.getElementById(videoElem[i].id).pause();
    }
  }
};

export const handlePauseAllVideo = (id = undefined) => {
  document.body.style.overflow = "auto";
  let videoElem = document.querySelectorAll("video");
  for (let i = 0; i < videoElem.length; ++i) {
    if (
      document.getElementById(videoElem[i].id).className !==
      "searchsuggestiondiv"
    ) {
      document
        .getElementById(videoElem[i].id)
        .play()
        .then((res) => {
          document.getElementById(videoElem[i].id).pause();
        });
    }
  }
};

export const replacepercentageSymbol = (str) => {
  let newStr = str.replaceAll("%", "VIZERTOPER");
  return newStr;
};
export const replaceVIZERTOPERText = (str) => {
  let newStr = str.replaceAll("VIZERTOPER", "%");
  return newStr;
};

export const getSearchedTime = (str) => {
  let hours = new Date(str).getHours();
  let minutes =
    new Date(str).getMinutes() < 10
      ? "0" + new Date(str).getMinutes()
      : new Date(str).getMinutes();
  return hours + ":" + minutes;
};
export const formatQuestionLength = (str) => {
  if (str === null) {
    return "";
  }
  if (str.length <= 40) {
    return str;
  } else {
    let newStr = str.slice(0, 40);
    newStr = newStr + "...";
    return newStr;
  }
};

export const removeLineBreak = (str) => {
  // let newStr = str.replaceAll("<br/>"," ");
  // newStr = newStr.replaceAll("<br>"," ");
  // newStr = newStr.replaceAll("</br>"," ");
  return str;
};

export const submitRatingSuccessToast = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export const ToastWarning = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export const dateFormater = () => {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    day = parseInt(day) + 1;
  day = day.toString();
  let year = d.getFullYear();
  year = year;
  month = parseInt(month);
  month = month.toString();
  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }
  let date2 = [year, month, day].join("-");
  return date2.toString();
};

export const expireDateFormater = (dt) => {
  var d = new Date();
  d = new Date(d.setMonth(d.getMonth() + dt));
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  day = parseInt(day);
  day = day.toString();
  let year = d.getFullYear();
  year = year;
  month = parseInt(month);
  month = month.toString();
  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }
  let date2 = [year, month, day].join("-");
  return date2.toString();
};

export const extractWidthFromImgtag = (url) => {
  var tmp = document.createElement("div");
  tmp.innerHTML = url;
  var width = tmp.querySelector("img").getAttribute("width");
  return width;
};

export const wrapImgtagWithDiv = (string) => {
  let oldStr = string;
  let newStr = string.split("<");
  newStr.filter((obj) => {
    if (obj.includes(";base64,")) {
      let url = `<${obj.split(">")[0]}>`;
      let widthImg = extractWidthFromImgtag(url);
      if (widthImg === null) {
        let replacedStr = `<div>${url}</div>`;
        oldStr = oldStr.replace(url, replacedStr);
      } else {
        let replacedStr = `<div width=${widthImg.toString()}>${url}</div>`;
        oldStr = oldStr.replace(url, replacedStr);
      }
    }
  });
  return oldStr;
};

export const filterUnansweredQA = (arr) => {
  let newArr = arr.filter((obj) => {
    if (obj.answersList.length > 0) {
      return obj;
    }
  });
  return newArr;
};

export const langArrFormat = (arr) => {
  let arr2 = [];
  let newArr = arr.filter((lang) => {
    arr2.push({
      label: lang,
      value: lang,
    });
  });
  return arr2;
};

export const cmReactToAngular = (type) => {
  let link;
  switch (type) {
    case "home":
      link = `${BASE_URL}/#/convoManager`;
      window.location.href = link;
      break;
    case "notification":
      link = `${BASE_URL}/#/convoManager?type=notification`;
      window.location.href = link;
      break;
    case "emailthread":
      link = `${BASE_URL}/#/convoManager?type=emailthread`;
      window.location.href = link;
      break;
    case "expertRecords":
      link = `${BASE_URL}/#/convoManager?type=expertRecords`;
      window.location.href = link;
      break;
    case "atomizer":
      link = `${BASE_URL}/#/convoManager?type=atomizer`;
      window.location.href = link;
      break;
    case "ingestedKnowledge":
      link = `${BASE_URL}/#/convoManager?type=ingestedKnowledge`;
      window.location.href = link;
      break;
    default:
      link = `${BASE_URL}/#/convoManager`;
      window.location.href = link;
      break;
  }
};

export const convertMinutesToDaysHoursMinutes = (minutes) => {
  let days = Math.floor(minutes / 1440); // 1 day = 1440 minutes
  let remainingMinutes = minutes % 1440;
  let hours = Math.floor(remainingMinutes / 60);
  let remainingSeconds = remainingMinutes % 60;
  let val = `${days}d ${hours}h ${remainingSeconds}m`;
  return val;
  //  && <CountUp start={1} end={val} duration={3.75} />;
};
export const momentit = (stime) => {
  if (Number(Date?.now()) - Number(stime) < 259200000) {
    return moment(new Date(Number(stime))).fromNow();
  } else {
    return moment(convertEpochToTimestamp(stime)).format("ll");
  }
};

export const filterVisibleTopics = (arr) => {
  if (arr === undefined) {
    return [];
  }
  let asdf = arr.filter((obj) => {
    obj.label = obj.name;
    obj.value = obj.indexId;
    return obj;
  });
  return asdf;
  // return arr;
};

export const filtercmDomains = (val, options) => {
  let asdf = options.filter((obj) => {
    if (val.includes(obj.value)) {
      return obj;
    }
  });
  return asdf;
  // return arr;
};
// const  addWidthToImgTags=(html)=>{
//   return html.replace(/(<img\s*[^>]*)(>)/gi, "$1 style='width:50%'$2");
// }
export const removeStylesFromHtml = (html) => {
  let newHtml = html.replace(
    /\s*style\s*=\s*(['"])(.*?)\1/gi,
    (match, quote, styles, offset, fullString) => {
      return /<\s*(table|td|th)\b/i.test(fullString.slice(0, offset))
        ? match
        : "";
    }
  );
  newHtml = newHtml.replace(/(<img\s*[^>]*)(>)/gi, "$1 style='width:50%'$2");
  newHtml = newHtml.replace(/(<video\s*[^>]*)(>)/gi, "$1 style='width:95%'$2");
  newHtml = newHtml.replace(
    /(<img\s*[^>]*)(>)/gi,
    "$1 onclick=\"window.open(this.src, '_blank')\"$2"
  );

  return newHtml;
};
export const settingListAdmin = {
  "Expert Routing": [
    {
      text: "Re-routing Interval",
      subText:
        "Maximum amount of time for an Expert to answer a question before it gets routed to a different Expert",
    },
    {
      text: "Abort Period",
      subText:
        "Maximum amount of time the Seeker should be waiting for an answer before sending it to the Conversation Manager",
    },
    {
      text: "Experts Assigned",
      subText:
        "Maximum Experts should be assigned to the question everytime the routing kicks in",
    },
    {
      text: "Max Acceptance SLA",
      subText:
        "Maximum SLA time that an Expert can choose while accepting a question",
    },
    {
      text: "Minimum Answers",
      subText:
        "Minimum answers every question should have from Experts, i.e. question will keep routing until it gets this many answers",
    },
    {
      text: "Curation Routing Method",
      subText:
        "Based on the selected method, the Question keeps routing until the answer gets curated",
    },
  ],
  "Search Results": [
    {
      text: "User Ranking",
      subText: "Enable/Disable User Ranking",
    },
    {
      text: "Text Summarization",
      subText: "Enable/Disable Text summarization",
    },
    {
      text: "Search Count Email Records",
      subText: "Maximum amount of Email records shown",
    },
    {
      text: "Search Count Doc Records",
      subText: "Maximum amount of Doc records shown",
    },
    {
      text: "Search Count Expert Records",
      subText: "Maximum amount of Expert records shown",
    },
    {
      text: "Auto Suggest Count Expert Records",
      subText: "Maximum amount of auto suggest records shown",
    },
  ],
  "Expert Settings": [
    {
      text: "Urgent Question Timeout Period",
      subText: "Timeout period to add new experts in queue",
    },
    {
      text: "Unanswered Question Timeout Period",
      subText: "Default time frame for unanswered questions to be shown",
    },
    {
      text: "Declined Answer Window",
      subText:
        "Maximum amount of time in which the Seeker's declined questions are listed",
    },
  ],
  "Knowledge Curation": [
    {
      text: "Expert Curation Evergreen Window",
      subText:
        "Default time frame dedicated to the Mark Evergreen function in Expert Curation View",
    },
    {
      text: "Expert Answer Expiration",
      subText:
        "Maximum amount of time in which the Expert's answer is not expired",
    },
    {
      text: "Seeker Curation Visiblity",
      subText: "Enable/Disable Seeker Curation Visiblity",
    },
  ],
  "Seeker Home": {
    "User Level": {
      key: "User Level",
      data: [
        {
          text: "User Searches",
          subText: "Total queries searched by users",
        },
        {
          text: "User Knowledge Records Viewed",
          subText: "Total knowledge records viewed by users",
        },
        {
          text: "User Question Submitted",
          subText: "Total questions asked by single user",
        },
        {
          text: "User Knowledge Records Viewed MinCount",
          subText: "Knowledge Records Viewed MinCount",
        },
        {
          text: "User Overall Searches MinCount",
          subText: "User Overall Searches MinCount",
        },
        {
          text: "User Questions Submitted To Experts MinCount",
          subText: "Total knowledge records viewed by single user",
        },
      ],
    },
    "Total Users": {
      key: "Total Users",
      data: [
        {
          text: "Overall Searches",
          subText: "Total queries searched by users",
        },
        {
          text: "Overall Knowledge Records Viewed",
          subText: "Total knowledge records viewed by users",
        },
        {
          text: "Overall Questions Answered",
          subText: "Total questions answered by users",
        },
        {
          text: "Overall LoggedIn",
          subText: "Total users logged In",
        },
        {
          text: "Overall Document Scraped",
          subText: "Total document scraped",
        },
        {
          text: "Overall Likes",
          subText: "Total questions liked by users",
        },
        {
          text: "Overall Key Terms",
          subText: "Total viewed Keyterm",
        },
        {
          text: "Overall Question View",
          subText: "Total Question View by users",
        },
        {
          text: "Overall Knowledge Updates",
          subText: "Total Knowledge Updates",
        },
      ],
    },
    "System Level": {
      key: "System Level",
      data: [
        {
          text: "System Knowledge Records Viewed MinCount",
          subText: "Knowledge Records Viewed MinCount",
        },
        {
          text: "System Knowledge Updates MinCount",
          subText: "System Knowledge Updates MinCount",
        },
        {
          text: "System Likes MinCount",
          subText: "System Likes MinCount",
        },
        {
          text: "System Overall Searches MinCount",
          subText: "System Overall Searches",
        },
        {
          text: "System Questions Answered MinCount",
          subText: "System Questions Answered MinCount",
        },
        {
          text: "System Questions DocView MinCount",
          subText: "System Questions DocView",
        },
        {
          text: "System Trending KeyTerms Views MinCount",
          subText: "System Trending KeyTerms ViewsMinCount",
        },
        {
          text: "System User Logins MinCount",
          subText: "System User Logins MinCount",
        },
        {
          text: "System Docs Scraped MinCount",
          subText: "System Docs Scraped MinCount",
        },
        {
          text: "System Response Time",
          subText: "System Response Time",
        },
      ]}
  },
  "Agentic Settings":
  [
 
  ],
}


export const toggleChartRegionValues = (value) => {
  if (value !== 2) {
    return true;
  }
};
export const langArrFormatTwo = (arr) => {
  let arr2 = [];
  let newArr = arr.filter((lang) => {
    arr2.push({
      label: lang,
      value: lang,
      name: lang,
    });
  });
  return arr2;
};

export const convertSourcesTovalues = (sources) => {
  let output = []
  Object.values(sources)
  .flat().map(source=>{
    if(source.checked){
    output.push(source.value)
    }
  })
  return output.toString();
}

export const emailRedirection = (paramExist) => {
  if (paramExist.includes("open=")) { //expert
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Expert"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[1].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/expertHome/open/${
      paramExist.split("&")[0].split("=")[1]
    }`;
  }
  if (paramExist.includes("emailaction=")) { //expert
    
    window.location.href = `${UI_BASE_URL}/emailAction/${
      paramExist.split("=")[1]
    }`;
  }
  if (paramExist.includes("answered=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[1].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/seekerHome/answered/${
      paramExist.split("&")[0].split("=")[1]
    }`;
  }
  if (paramExist.includes("shared=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[1].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/seekerHome/shared/${
      atob(paramExist.split("&")[0].split("=")[1])
    }`;
  }
  if (paramExist.includes("requestupdateseeker=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[1].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/seekerHome/requestupdateseeker/${
      paramExist.split("&")[0].split("=")[1]
    }`;
  }
  if (paramExist.includes("requestupdateexpert=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Expert"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[2].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/expertHome/requestupdateseeker/${
      paramExist.split("&")[0].split("=")[1]
    }`;
  }
  if (paramExist.includes("Question=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Expert"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[1].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/expertHome/anotherExpertAnswered/${
      paramExist.split("&")[0].split("=")[1]
    }`;
  }
  if (paramExist.includes("transferred=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Expert"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[1].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/expertHome/transferred/true`;
  }
  if (paramExist.includes("ask=")) {
    const urlParams = new URLSearchParams(window.location.search);
    let askValue = urlParams.get('ask');
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[0].split("=")[1]
    );
    let val = askValue.replaceAll('\n'," ");
    // ${encodeURIComponent(replacepercentageSymbol(val))}
    window.location.href = `${UI_BASE_URL}/seekerHome/search/${
      encodeURIComponent(replacepercentageSymbol(val))}/false`;
  }
  if (paramExist.includes("trending=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[0].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/seekerHome/trending`;
  }
  if (paramExist.includes("mydownload=")) { //seeker
    localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
    localStorage.setItem(
      "ngStorage-currentGroup",
      paramExist.split("&")[0].split("=")[1]
    );
    window.location.href = `${UI_BASE_URL}/seekerHome/download`;
  }
};
 export const saveShowpadTokenWithExpiry = (token) => {
  const expiryTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour in ms
  const tokenObject = {
    value: token,
    expiry: expiryTime
  };
  localStorage.setItem("accessToken", JSON.stringify(tokenObject));
};

export const getShowpadToken = () => {
  const tokenString = localStorage.getItem("accessToken");
  if (!tokenString) return null;

  const tokenObject = JSON.parse(tokenString);
  const now = new Date().getTime();

  if (now > tokenObject.expiry) {
    localStorage.removeItem("accessToken"); // Clean up expired token
    return null;
  }

  return tokenObject.value;
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

